// src/config.js
const AppConfig = {
    title: "مەلەف - on tiktok",
    paragraph: "malaf",
    img: "https://i.postimg.cc/7LyLzSJ2/Screenshot-20250614-140808-Tik-Tok.jpg",
    url: "malaf",
    id: "7140625"
};

export default AppConfig;
